import {
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { API_URL } from "@/services/constants";
import { removeMultipleKeys } from "@/utils/function";

const TOKEN_KEY = "pluri_token";
const REFRESH_KEY = "pluri_refresh_token";
const USER_DETAIL_KEY = "user_detail";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  // credentials: "include",
  prepareHeaders: (headers) => {
    const TOKEN_KEY = localStorage.getItem("pluri_token");

    if (TOKEN_KEY) {
      headers.set("authorization", `Bearer ${TOKEN_KEY}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  let result = await baseQuery(args, api, extraOptions);

  if ((result.error as FetchBaseQueryError)?.status === 401) {
    // Get the refresh token from the local storage
    const refreshToken = "pluri_refresh_token";

    if (!refreshToken) {
      removeMultipleKeys([TOKEN_KEY, REFRESH_KEY, USER_DETAIL_KEY, "toggle", "selectedLanguage"]);
      window.location.pathname = "/login";
    }

    // send refresh token to get new access token
    const refreshResult: any = await baseQuery(
      {
        url: "/auth/refresh/",
        method: "POST",
        body: {
          refresh: refreshToken,
        },
      },
      api,
      extraOptions
    );

    if (refreshResult.data) {
      // store the new token

      // retry the original query with new access token
      result = await baseQuery(args, api, extraOptions);
    } else {
      removeMultipleKeys([TOKEN_KEY, REFRESH_KEY, USER_DETAIL_KEY, "toggle"]);
      window.location.pathname = "/login";
    }
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
